import { Controller } from 'stimulus'

import { csrfToken } from '@react/helpers/fetch'
import { confirmScheduleConflict } from '@react/calendar/conflictConfirm'
import './shared/coordination_map.css'

export default class extends Controller {
  static targets = ['panel', 'refreshed']

  connect() {
    const seconds = parseInt(this.data.get('refresh'), 10)
    if (seconds > 0) this._timer = setInterval(this.refresh, seconds * 1000)
  }

  disconnect() {
    clearInterval(this._timer)
  }

  refresh = () => {
    if (document.hidden || this._busy) return

    document.dispatchEvent(new CustomEvent('workorder:updated', { detail: { id: null } }))
    if (this.hasRefreshedTarget) {
      this.refreshedTarget.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }
  }

  submit(event) {
    const form = event.target.form
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit()
  }

  propose(event) {
    event.preventDefault()
    event.stopPropagation()
    const card = event.currentTarget.closest('.map__small-card__container')
    const pin  = card && card.querySelector('[data-action*="map#clickIcon"]')
    if (pin) pin.click()
    this._load(event.currentTarget.dataset.url)
  }

  close(event) {
    if (event) event.preventDefault()
    this._busy = false
    this.panelTarget.innerHTML = ''
    this.panelTarget.classList.add('d-none')
  }

  plan(event) {
    event.preventDefault()
    const button = event.currentTarget
    this._plan(button, false)
  }

  _load(url) {
    this._busy = true
    this.panelTarget.classList.remove('d-none')
    this.panelTarget.innerHTML = '<div class="loading-spinner-container"><div id="loading-spinner"></div></div>'
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(response => (response.ok ? response.text() : ''))
      .then(html => {
        this.panelTarget.innerHTML = html
        this.panelTarget.querySelectorAll('[data-day-url]').forEach(link => {
          link.addEventListener('click', e => {
            e.preventDefault()
            this._load(link.dataset.dayUrl)
          })
        })
      })
  }

  _plan(button, confirmed) {
    button.disabled = true
    fetch(button.dataset.url, {
      method:      'POST',
      credentials: 'same-origin',
      headers:     { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrfToken() },
      body:        JSON.stringify({
        technician_id:      button.dataset.technician,
        starts_at:          button.dataset.startsAt,
        confirmed_conflict: confirmed
      })
    })
      .then(response => response.json().catch(() => ({})).then(data => ({ status: response.status, data })))
      .then(({ status, data }) => {
        button.disabled = false
        if (status === 409 && data.conflict) {
          if (confirmScheduleConflict(data.conflict)) this._plan(button, true)
          return
        }
        if (status !== 200) {
          window.alert(this.data.get('error'))
          return
        }
        this.close()
        if (typeof window.flashNotice === 'function') window.flashNotice(data.message)
        document.dispatchEvent(new CustomEvent('workorder:updated', { detail: { id: data.id } }))
      })
      .catch(() => { button.disabled = false })
  }
}
